import { Component } from '@angular/core';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { closeWindow } from '../shared/utils/utils';

@Component({
  selector: 'app-expired-link',
  standalone: true,
  imports: [LottieComponent],
  templateUrl: './expired-link.component.html',
  styleUrl: './expired-link.component.css'
})
export class ExpiredLinkComponent {
  options: AnimationOptions = {
    path: 'assets/animations/expired-link.json',
    loop: 1
  }

  close() {closeWindow()}
}
